export const customNames = [
    'Tony',
    'Dennis',
    'Håvard',
    'Alfred',
    'Tutta',
    'Mimi',
    'Gollum',
    'Frodo',
    'Lando',
    'Gandalf',
    'C3PO',
    'Yoda',
    'Leia',
    'Chewbacca',
    'Han Solo',
    'Luke Skywalker',
    'Darth Vader',
    'Obi-Wan Kenobi',
    'R2D2',
    'Grogu',
    'Mando',
    'Groot',
    'Rocket',
    'Bob',
    'Sheldon',
    'Penny',
    'Sai',
    'Carlos',
    'Nemo',
    'Dory',
    'Jack Sparrow',
    'Lighting McQueen',
    'Elsa',
    'Arya Stark',
    'Jon Snow',
    'Daenerys Targaryen',
    'Tyrion Lannister',
    'Steve Rogers',
    'Sebastian',
    'Robin',
    'Peter Parker',
    'Clark Kent',
    'Bruce Wayne',
    'Wolverine',
    'Deadpool',
    'Hulk',
    'Thor',
    'Sven',
    'Michal',
    'Kari',
    'Ola',
    'Mia',
];

export default customNames;
